module.exports = __webpack_public_path__ + "img/46.c8c62628.png";